import { accessRole } from "../../../helpers/access_role"
import ErrorAccess from '../../../components/Error/Content/Access'
import React, { useEffect } from "react"
import { Redirect } from "react-router-dom"

import Index from './Index/View'
// import List from './List/View'
// import ListPegawai from './ListPegawai/View'
import Create from './Create/View'
import Detail from './Detail/View'
// import Update from './Update/View'
import Approve from './Approve/View'
import Prediksi from './Prediksi/View'

import Pegawai from './Pegawai/View'
import CreatePenghargaan from './CreatePenghargaan/View'
import DetailPenghargaan from './DetailPenghargaan/View'
import ApprovePenghargaan from './ApprovePenghargaan/View'
import RejectPenghargaan from './RejectPenghargaan/View'

const RouteView = (props) => {
    const { params } = props    
	const queryParams = new URLSearchParams(props.location.search);
    const _id = queryParams.get('id')
    const _uuid = queryParams.get('uuid')
    const _employee_uuid = queryParams.get('employee')
    const _recomendation_uuid = queryParams.get('award_type')
    const _award_uuid = queryParams.get('award_uuid')
    const _create = queryParams.get('create')
    const _prediksi = queryParams.get('prediksi')
    const _list = queryParams.get('list')
    const _detail = queryParams.get('detail')
    const _update = queryParams.get('update')
    const _delete = queryParams.get('delete')
    const _approve = queryParams.get('approve')
    const _reject = queryParams.get('reject')
    const _print = queryParams.get('print')
    const _pegawai = queryParams.get('pegawai')

    if (_pegawai != null) {
        if (_create != null) {
            return accessRole('create') ? <CreatePenghargaan uuid={_uuid} />: <ErrorAccess />
        } else if (_approve != null) {
            return accessRole('approve') ? <ApprovePenghargaan uuid={_uuid} award_uuid={_award_uuid} employee_uuid={_employee_uuid} recomendation_uuid={_recomendation_uuid}  />: <ErrorAccess />
        } else if (_detail != null) {
            return accessRole('read') ? <DetailPenghargaan uuid={_uuid} award_uuid={_award_uuid} employee_uuid={_employee_uuid} recomendation_uuid={_recomendation_uuid} /> : <ErrorAccess />
        } else if (_reject != null) {
            return accessRole('approve') ? <RejectPenghargaan uuid={_uuid} award_uuid={_award_uuid} />: <ErrorAccess />
        }
        return accessRole('update') ? <Pegawai uuid={_uuid} /> : <ErrorAccess />
    }

    if (_create != null) {
    	return accessRole('create') ? <Create /> : <ErrorAccess />
    } else if (_approve != null) {
     	return accessRole('approve') ? <Approve uuid={_uuid} /> : <ErrorAccess />
    } else if (_detail != null) {
        return accessRole('read') ? <Detail uuid={_uuid} /> : <ErrorAccess />
    } else if (_prediksi != null) {
        return accessRole('read') ? <Prediksi /> : <ErrorAccess />
    }
    // } else if (_update != null) {
    // 	return accessRole('update') ? <Update uuid={_uuid} /> : <ErrorAccess />
    // } else if (_list != null) {
    // 	return accessRole('read') ? <List uuid={_uuid} /> : <ErrorAccess />
    // } else if (_delete != null) {
    // 	return null
    // } else if (_approve != null) {
    // 	return accessRole('approve') ? <Approve uuid={_uuid} /> : <ErrorAccess />
    // } else if (_print != null) {
    // 	return null
    // }

    // Jika Admin
    if (accessRole('approve')) {
        return accessRole('read') ? <Index /> : <ErrorAccess />
    } else {
        return accessRole('read') ? null : <ErrorAccess />
    }

}

export default RouteView